<template>
    <div class="container-fluid">
        <nav-header :navItems="[
            {
                name: 'Analyze',
                link: {
                    name: 'Map My Data Streaming'
                }
            },
            {
                name: 'History',
                link: {
                    name: 'Map My Data Invocations'
                }
            },
            {
                name: 'Admin History',
                link: {
                    name: 'All Map My Data Invocations'
                },
                disable: !$store.getters.userRoles.isAqferAdmin && !$store.getters.userRoles.isAqferManager
            },
            {
                name: `${chat ? chat.resourceId : 'Chat History'}`,
                link: {
                    name: 'Map My Data Specific Invocation',
                    params: {
                        id: ` `,
                    }
                },
                closeTab: true,
                disable: true,
            }
        ]" pretitle="aqfer Data Transformation" title="Map My Data" @nav-close-clicked="closeClick">
        </nav-header>
        <div>
            <router-view v-on:setChat="setChat">
            </router-view>
        </div>
    </div>
</template>
<script>
import NavHeader from "../../components/NavHeader.vue";
export default {
    name: "Map My Data",
    components: { NavHeader },
    data() {
        return {
            chat: null
        }
    },
    methods: {
        setChat(chat) {
            this.chat = chat;
        },
        closeClick() {
            this.chat = null;
            this.$router.push({
                name: "All Map My Data Invocations",
            });
        },
    }
}
</script>
<style></style>